<template>
    <div class="carousel">
        <div class="carousel-grid">
            <movie-list v-for="(movie, key) in movies" :movie="movie" :key="movie.id" :index="key"></movie-list>
        </div>
    </div>
</template>


<script>
    import MovieTeaserDefault from './MovieTeaserDefault.vue';
    import {EventBus} from '../lib/EventBus';
    import Vue from 'vue';

    export default {

        components: {
            movieList: MovieTeaserDefault
        },

        data() {
            return {
                movies : [],
            }
        },

        mounted () {
            this.movies = this.getMovies();
            EventBus.$on('receive-movies', movies => {
                this.movies = this.getMovies();
            });
        },

        methods: {
            getMovies() {
                let movies = window.fetchMovies();
                if (movies.length > 0) {
                    movies = _.filter(movies, { 'category': 'Bahntechnik' });
                }
                return movies;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// BahntechnikMoviesList.vue?9a4338b0